<template>
  <div class="detail-wrap">
    <el-form ref="editForm" :model="formData">
      <div class="d-header clearfix">
        <div class="fl">
          <i class="el-icon-info"/>
          {{ dataId ? '查看' : '新增' }}知识文档
        </div>
        <div class="fr">
          <el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
        </div>
      </div>
      <div>

        <!-- 品牌信息 -->
        <div class="d-cont edit-mce-box">
          <div class="d-item">
            <div class="title first">
              <b>主信息</b>
            </div>
            <table class="table-detail">
              <tbody>
              <tr>

                <th>
                  <em class="f-red">*</em>
                  知识库分类
                </th>
                <td>
                  <el-cascader
                    v-model="formData.knowledgeTypeId"
                    :options="knowledgeTypeOption"
                    @change="handleChange"></el-cascader>
<!--                  <el-select v-model="formData.knowledgeTypeId">-->
<!--                    <el-option label="选项值" :value="1"/>-->
<!--                    <el-option label="文本" :value="2"/>-->
<!--                  </el-select>-->
                </td>
                <th>
                  <em class="f-red">*</em>
                  标题
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.title" clearable/>
                </td>
                <th>
                  关键字
                </th>
                <td>
                  <el-input type="text" autocomplete="off" v-model="formData.keyWords" clearable/>
                </td>
              </tr>
              <tr>
                <th>
                  <em class="f-red">*</em>
                  是否置顶
                </th>
                <td>
                  <el-select v-model="formData.isTop">
                    <el-option label="否" :value="0"/>
                    <el-option label="是" :value="1"/>
                  </el-select>
                </td>
                <th>
                  <em class="f-red">*</em>
                  是否发布
                </th>
                <td>
                  <el-select v-model="formData.isPublic">
                    <el-option label="否" :value=0></el-option>
                    <el-option label="是" :value=1></el-option>
                  </el-select>
                </td>

              </tr>
              <tr>
                <th>创建人</th>
                <td>{{ formData.createBy }}</td>
                <th>创建时间</th>
                <td>{{ formData.createTime }}</td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="d-item" style="height: 60vh;">
            <div class="title first">
              <b>内容</b>
            </div>
            <div>
              <quill-editor class="editor"
                            ref="myTextEditor"
                            v-model="formData.content"
                            :options="editorOption"
                            @blur="onEditorBlur($event)"
                            @focus="onEditorFocus($event)"
                            @ready="onEditorReady($event)"
                            @change="onEditorChange($event)">
              </quill-editor>
            </div>
          </div>
        </div>

      </div>
    </el-form>
    <productCategoryDialog v-if="showProductCategoryDialog" :visiable.sync="showProductCategoryDialog" multi="false"
                           @confirm="confirmCategory"/>
  </div>
</template>
<script>
import {
  initVxeTable
} from '@/const/crud/admin/table';
import Tinymce from '@/components/Tinymce';
import request from "@/router/axios";
import api from "@/api/projectApi";
// toolbar标题
const titleConfig = [
  {Choice: '.ql-insertMetric', title: '跳转配置'},
  {Choice: '.ql-bold', title: '加粗'},
  {Choice: '.ql-italic', title: '斜体'},
  {Choice: '.ql-underline', title: '下划线'},
  {Choice: '.ql-header', title: '段落格式'},
  {Choice: '.ql-strike', title: '删除线'},
  {Choice: '.ql-blockquote', title: '块引用'},
  {Choice: '.ql-code', title: '插入代码'},
  {Choice: '.ql-code-block', title: '插入代码段'},
  {Choice: '.ql-font', title: '字体'},
  {Choice: '.ql-size', title: '字体大小'},
  {Choice: '.ql-list[value="ordered"]', title: '编号列表'},
  {Choice: '.ql-list[value="bullet"]', title: '项目列表'},
  {Choice: '.ql-direction', title: '文本方向'},
  {Choice: '.ql-header[value="1"]', title: 'h1'},
  {Choice: '.ql-header[value="2"]', title: 'h2'},
  {Choice: '.ql-align', title: '对齐方式'},
  {Choice: '.ql-color', title: '字体颜色'},
  {Choice: '.ql-background', title: '背景颜色'},
  {Choice: '.ql-image', title: '图像'},
  {Choice: '.ql-video', title: '视频'},
  {Choice: '.ql-link', title: '添加链接'},
  {Choice: '.ql-formula', title: '插入公式'},
  {Choice: '.ql-clean', title: '清除字体格式'},
  {Choice: '.ql-script[value="sub"]', title: '下标'},
  {Choice: '.ql-script[value="super"]', title: '上标'},
  {Choice: '.ql-indent[value="-1"]', title: '向左缩进'},
  {Choice: '.ql-indent[value="+1"]', title: '向右缩进'},
  {Choice: '.ql-header .ql-picker-label', title: '标题大小'},
  {Choice: '.ql-header .ql-picker-item[data-value="1"]', title: '标题一'},
  {Choice: '.ql-header .ql-picker-item[data-value="2"]', title: '标题二'},
  {Choice: '.ql-header .ql-picker-item[data-value="3"]', title: '标题三'},
  {Choice: '.ql-header .ql-picker-item[data-value="4"]', title: '标题四'},
  {Choice: '.ql-header .ql-picker-item[data-value="5"]', title: '标题五'},
  {Choice: '.ql-header .ql-picker-item[data-value="6"]', title: '标题六'},
  {Choice: '.ql-header .ql-picker-item:last-child', title: '标准'},
  {Choice: '.ql-size .ql-picker-item[data-value="small"]', title: '小号'},
  {Choice: '.ql-size .ql-picker-item[data-value="large"]', title: '大号'},
  {Choice: '.ql-size .ql-picker-item[data-value="huge"]', title: '超大号'},
  {Choice: '.ql-size .ql-picker-item:nth-child(2)', title: '标准'},
  {Choice: '.ql-align .ql-picker-item:first-child', title: '居左对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="center"]', title: '居中对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="right"]', title: '居右对齐'},
  {Choice: '.ql-align .ql-picker-item[data-value="justify"]', title: '两端对齐'}
]
export default {
  inject: ['reload'],
  name: 'edit',
  props: {
    _dataId: [String, Number]
  },
  components: {
    Tinymce,
  },
  data() {
    return {
      formData: {
        knowledgeTypeId: null,  // 知识库分类ID,关联bas_knowledge_type.id
        title: null,  // 标题
        keyWords: null,  // 关键字
        isTop: 0,  // 是否置顶:0否1是
        isPublic: 1,  // 是否发布:0否1是
        content: null,  // 内容;注意为富文本
      },
      knowledgeTypeOption: [],


      img_b: "",
      upload_btn: false, // 是否隐藏上传图片按钮
      radio: '1',
      showEdit: false,
      valuetype: 'model',
      textarea: '',
      //  value1: true,
      value2: false,
      value3: true,
      activeName: 'first',
      dialog: {
        one: false,
      },
      lan: 'zh_CN',
      isEdit: false,
      tabIndex: 'first',
      dataId: '',
      intValueSplit: '',
      // 基本信息
      service: {
        pic: '',
      },
      tenant: {
        status: 0,
        tenantAttachmentDTOs: [],
        projectCode: '',
        projectName: '',
        valueType: 1,
        valueSplit: '',
        usable: 1,
        seq: 0
      },
      showProductCategoryDialog: false,
      editorOption: {
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
            ["blockquote", "code-block"], // 引用  代码块
            [{header: 1}, {header: 2}], // 1、2 级标题
            [{list: "ordered"}, {list: "bullet"}], // 有序、无序列表
            [{script: "sub"}, {script: "super"}], // 上标/下标
            [{indent: "-1"}, {indent: "+1"}], // 缩进
            // [{'direction': 'rtl'}],                         // 文本方向
            [{size: ["small", false, "large", "huge"]}], // 字体大小
            [{header: [1, 2, 3, 4, 5, 6, false]}], // 标题
            [{color: []}, {background: []}], // 字体颜色、字体背景颜色
            [{font: []}], // 字体种类
            [{align: []}], // 对齐方式
            ["clean"], // 清除文本格式
            ["link", "image", "video"] // 链接、图片、视频
          ], //工具菜单栏配置
        },
        placeholder: '请在这里添加产品描述', //提示
        readyOnly: false, //是否只读
        theme: 'snow', //主题 snow/bubble
      }
    };
  },
  computed: {
    // enabled: {}
    editor() {
      return this.$refs.myTextEditor.quillEditor;
    }
  },
  created() {
    if (this._dataId && !isNaN(this._dataId)) this.dataId = this._dataId;
    // console.log(this.tenant,"tenant的值");
  },
  mounted() {
    this.initTitle();
    this.getData();
    console.log(this.tenant, "tenant的值");
    console.log(this._dataId, "_dataId的值");
  },
  methods: {
    handleChange() {

    },











    initTitle() {
      document.getElementsByClassName('ql-editor')[0].dataset.placeholder = ''
      for (let item of titleConfig) {
        let tip = document.querySelector('.quill-editor ' + item.Choice)
        if (!tip) continue
        tip.setAttribute('title', item.title)
      }
    },
    // 失去焦点
    onEditorBlur(editor) {
    },
    // 获得焦点
    onEditorFocus(editor) {
    },
    // 开始
    onEditorReady(editor) {
    },
    // 值发生变化
    onEditorChange(editor) {
      this.content = editor.html;
      console.log(editor);
    },





    getData() {
      if (this.dataId && !isNaN(this.dataId)) {
        this.isEdit = true;
        this.$http({
          url: api.basKnowledge.getDataUrl,
          method: 'post',
          data: {
            id: this.dataId
          },
          isLoading: true,
          modalStrictly: true,
        }).then(response => {
          this.formData = response.data.data;
        })
      }
    },
    saveData() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          this.$baseConfirm('您确定要保存吗？').then(() => {
            var url = (this.isEdit ? api.basKnowledge.updateDataUrl : api.basKnowledge.addDataUrl);
            this.$http({
              url: url,
              method: `post`,
              data: this.formData,
              isLoading: true,
            }).then(res => {
              this.$message.success("保存成功！")
              this.reload()
              // this.$emit('editViewDataUpdate')
            }).catch(e => {
              console.error(e)
              this.$message.error("保存失败！")
            });
          });
        }
      });
    },

  },
};

</script>
<style lang="scss" scoped>

.editor {
  line-height: normal !important;
  height: 43vh;
}

.ql-snow .ql-tooltip[data-mode=link]::before {
  content: "请输入链接地址:";
}

.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: '保存';
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode=video]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: '14px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
  content: '10px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
  content: '18px';
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
  content: '32px';
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: '文本';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: '标题1';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: '标题2';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: '标题3';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: '标题4';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: '标题5';
}

.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: '标题6';
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: '标准字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
  content: '衬线字体';
}

.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
  content: '等宽字体';
}
</style>
